module.exports = __webpack_public_path__ + "img/Image3.783b93a5.png";